"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustoText = void 0;
const errors_1 = require("../utils/errors");
class CustoText {
    constructor(text) {
        this.$$end$$ = true;
        this.text = text;
    }
    static create(text) {
        return new CustoText(text);
    }
    getRaw() {
        return this.text;
    }
    useTransformed(props = {}, textTransformer) {
        let transformed;
        try {
            transformed = textTransformer
                ? textTransformer(this.text)
                : this.text;
        }
        catch (e) {
            if (!(e instanceof errors_1.CustoTypeError))
                throw e;
            transformed = this.text;
        }
        if (props.disableTextTransformer)
            transformed = this.text;
        return transformed;
    }
    render(props, textTransformer) {
        const transformed = this.useTransformed(props, textTransformer);
        if (typeof transformed === "number")
            return transformed.toString();
        return transformed;
    }
    clone() {
        return new CustoText(this.text);
    }
}
exports.CustoText = CustoText;
